import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=anon, object=user
  const [bootError, setBootError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    refresh().catch((e) => setBootError(e.message));
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.requires_verification) return { requires_verification: true, email: data.email };
    if (data.token) localStorage.setItem("nexa_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const signup = async (email, password, name) => {
    const { data } = await api.post("/auth/signup", { email, password, name });
    if (data.requires_verification) return { requires_verification: true, email: data.email };
    if (data.token) localStorage.setItem("nexa_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("nexa_token");
    setUser(null);
  };

  const updateProfile = async (profile) => {
    const { data } = await api.put("/auth/profile", profile);
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, refresh, login, signup, logout, updateProfile, setUser, bootError }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
